// Pure SVG bar chart for client-computed series (no chart lib by design).
export function BarMini({ data, className }: { data: { date: string; count: number }[]; className?: string }) {
  const W = 100
  const H = 32
  const max = Math.max(1, ...data.map(d => d.count))
  const bw = W / Math.max(1, data.length)
  return (
    <svg viewBox={`0 0 ${W} ${H}`} className={className} preserveAspectRatio="none" aria-hidden>
      {data.map((d, i) => {
        const h = Math.max(0.5, (d.count / max) * (H - 2))
        return (
          <rect key={d.date + i} x={i * bw + bw * 0.15} y={H - h} width={bw * 0.7} height={h}
            rx={1} fill="hsl(var(--primary))" opacity={d.count === 0 ? 0.25 : 0.9} />
        )
      })}
    </svg>
  )
}
